import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';
import { get } from 'lodash';

import { ApplicationTaskEnum } from '../../constants/applicationTasks';
import { useWorkflowPathname } from '../../hooks/useWorkflowPathname/useWorkflowPathname';
import { ApplicationDataInterface } from '../../pages/Applications/applicationData.interface';
import { NO_TASKS_CONTENT } from '../../services/task/taskService';
import { FailedSubmissionTaskCard } from '../shared/FailedSubmission/FailedSubmissionTaskCard/FailedSubmissionTaskCard';
import { InfoBlock } from '../shared/InfoBlock/InfoBlock';
import { QueuedSubmissionTaskCard } from '../shared/QueuedSubmission/QueuedSubmissionTaskCard/QueuedSubmissionTaskCard';
import { Tasks } from './styles';
import { TaskCard } from './TaskCard';

export const ApplicationTasks = ({
  isList,
  availableTasks,
  state,
  type,
}: {
  isList?: boolean;
  availableTasks: any;
  state: ApplicationDataInterface;
  type: 'application' | 'loan';
}) => {
  const workflowName = useWorkflowPathname();
  const noTasksContent = NO_TASKS_CONTENT[type][workflowName];

  const applicationStatus = get(
    state,
    'currentVehicle.checklightSession.status',
  );
  const isQueuedForSubmission =
    applicationStatus === ChecklightSessionStatus.QUEUED_FOR_SUBMISSION;
  const isFailedSubmission =
    applicationStatus === ChecklightSessionStatus.FAILED_SUBMISSION;

  if (isQueuedForSubmission) {
    return (
      <Tasks data-testid="queuedSubmissionTasks">
        <QueuedSubmissionTaskCard state={state} />
      </Tasks>
    );
  }

  if (isFailedSubmission) {
    return (
      <Tasks data-testid="failedSubmissionTasks">
        <FailedSubmissionTaskCard state={state} />
      </Tasks>
    );
  }

  return availableTasks?.length ? (
    <Tasks>
      {isList ? (
        availableTasks.map((task: ApplicationTaskEnum) => (
          <TaskCard key={`list-${task}`} state={state} task={task} />
        ))
      ) : (
        <TaskCard state={state} task={availableTasks[0]} />
      )}
    </Tasks>
  ) : (
    <InfoBlock title={noTasksContent.title} disableMargin>
      <span>{noTasksContent.body}</span>
    </InfoBlock>
  );
};
